
import { defineComponent, onMounted } from 'vue'
import BusinessInfoSideBar from '@/components/BusinessInfoSideBar.vue'
import BusinessInfoForm from '@/components/BusinessInfoForm.vue'
import { trackPendoEvent } from '../util/pendoConfig'

export default defineComponent({
  name: 'BusinessInfoPage',
  components: {
    BusinessInfoSideBar,
    BusinessInfoForm
  },
  setup() {
    onMounted(() => {
      trackPendoEvent('Onboarding Business Info Page',{})
    })
    return {}
  }
})
